module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("haVHN"))).then(() => module.bundle.root('hEqeo'));